import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_store_interaction } from '../../../_fields/_base/_enums/ENUM__field_store_interaction';
import { FIELD_PRIMITIVE__bool } from '../../../_fields/_primitives/FIELD_PRIMITIVE__bool';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '../../../_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { ENUM__image_asset_category } from '../../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../../_fields/image/FIELD__image_asset';
import { ENUM__field_role } from '../../_base/ENUM__field_role';
import { ENUM__invocation_type } from '../../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../../_base/INVOCATION__base';

export class INVOCATION_VISION_ML__control_line_guidance_hed extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.INVOCATION_VISION_ML__LINE__HED;

  /*
   * FIELDS
   */
  @FIELD_PRIMITIVE__string_hash_ml_asset.init_input_with_type(ENUM__ml_asset_type.VISION)
  model!: FIELD_PRIMITIVE__string_hash_ml_asset;

  @FIELD__image_asset.init_as_input(
    { category: ENUM__image_asset_category.IMAGE },
    {
      field_role: ENUM__field_role.IMAGE__MAIN,
      store__interaction: ENUM__field_store_interaction.READ_AND_WRITE,
      store__family: ENUM__ml_asset_family.NONE,
    },
  )
  image!: FIELD__image_asset;

  @FIELD_PRIMITIVE__bool.init_as_input({ value: false })
  scribble!: FIELD_PRIMITIVE__bool;

  /*
   * OUTPUT
   */

  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.LINE__SOFT_EDGE })
  out!: FIELD__image_asset;

  /*
   * PROPERTIES
   */
  get family() {
    return ENUM__ml_asset_family.VISION_HED;
  }

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.VISION_ML__LINE__HED);
  }
}
